import { combineReducers } from 'redux'
import dashboard from './dashboard/DashboardReducer'
import login from './login'
import mixedHealthServers from './dashboard/mixedHealthServers/MixedHealthServersReducer'
import stats from './dashboard/stats/StatsReducer'
import problematicServices from './dashboard/problematicServices/ProblematicServicesReducer'
import containersProblematicServices from './dashboard/containersProblematicServices/ContainersProblematicServicesReducer'
import searchServices from './dashboard/searchServices/SearchServicesTableReducer'
import searchServiceById from './dashboard/searchByLogId/SearchServiceIdReducer'
import serverTree from './dashboard/serverTree/ServerTreeReducer'
import serviceStatus from './dashboard/ServiceStatusTableReducer'
import regions from './dashboard/regions/RegionsReducer'
import clusters from './dashboard/clusters/ClustersReducer'
import settings from './settings'
import licenses from './dashboard/Licenses/LicensesReducer'
import wrapper from './wrapper'
import {reducer as expiredApps} from './dashboard/expiredApps/ExpiredAppsReducer'

const rootReducer = combineReducers({    
    wrapper,
    settings,    
    login,
    problematicServices,
    containersProblematicServices,
    dashboard,
    serviceStatus,
    searchServices,
    searchServiceById,
    mixedHealthServers,
    serverTree,
    regions,
    clusters,
    licenses,
    stats,
    expiredApps,
})

export default rootReducer;
